export default "__VITE_ASSET__DZzcIp2n__"